export default `
-- CreateTable
CREATE TABLE "UserActivity" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "activity_name" TEXT NOT NULL,
    "object_type" TEXT NOT NULL,
    "object_id" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    CONSTRAINT "UserActivity_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);

-- RedefineTables
PRAGMA defer_foreign_keys=ON;
PRAGMA foreign_keys=OFF;
CREATE TABLE "new_Attribute" (
    "id" TEXT NOT NULL PRIMARY KEY,
    "parent_type" TEXT NOT NULL,
    "parent_id" TEXT NOT NULL,
    "name" TEXT NOT NULL,
    "value" TEXT NOT NULL,
    "workspace_id" TEXT NOT NULL,
    "created_by" TEXT NOT NULL,
    "created_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    "updated_at" DATETIME NOT NULL DEFAULT CURRENT_TIMESTAMP,
    CONSTRAINT "Attribute_workspace_id_fkey" FOREIGN KEY ("workspace_id") REFERENCES "Workspace" ("id") ON DELETE RESTRICT ON UPDATE CASCADE
);
INSERT INTO "new_Attribute" ("created_at", "created_by", "id", "name", "parent_id", "parent_type", "updated_at", "value", "workspace_id") SELECT "created_at", "created_by", "id", "name", "parent_id", "parent_type", "updated_at", "value", "workspace_id" FROM "Attribute";
DROP TABLE "Attribute";
ALTER TABLE "new_Attribute" RENAME TO "Attribute";
CREATE INDEX "Attribute_parent_type_idx" ON "Attribute"("parent_type");
CREATE INDEX "Attribute_parent_id_idx" ON "Attribute"("parent_id");
CREATE INDEX "Attribute_name_idx" ON "Attribute"("name");
CREATE INDEX "Attribute_workspace_id_idx" ON "Attribute"("workspace_id");
CREATE INDEX "Attribute_created_by_idx" ON "Attribute"("created_by");
CREATE INDEX "Attribute_created_at_idx" ON "Attribute"("created_at");
CREATE INDEX "Attribute_updated_at_idx" ON "Attribute"("updated_at");
PRAGMA foreign_keys=ON;
PRAGMA defer_foreign_keys=OFF;

-- CreateIndex
CREATE INDEX "UserActivity_activity_name_idx" ON "UserActivity"("activity_name");

-- CreateIndex
CREATE INDEX "UserActivity_object_type_idx" ON "UserActivity"("object_type");

-- CreateIndex
CREATE INDEX "UserActivity_object_id_idx" ON "UserActivity"("object_id");

-- CreateIndex
CREATE INDEX "UserActivity_workspace_id_idx" ON "UserActivity"("workspace_id");

-- CreateIndex
CREATE INDEX "UserActivity_created_by_idx" ON "UserActivity"("created_by");

-- CreateIndex
CREATE INDEX "UserActivity_created_at_idx" ON "UserActivity"("created_at");

-- CreateIndex
CREATE INDEX "UserActivity_updated_at_idx" ON "UserActivity"("updated_at");
`;
